export default function TrustSection() {
  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="px-6 md:px-10 max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          <div className="lg:w-5/12">
            <p className="text-xs text-foreground-500 uppercase tracking-widest mb-4 whitespace-nowrap">
              Почему выбирают Yoybuy Spreadsheet
            </p>
            <div className="text-lg md:text-xl text-foreground-800 leading-relaxed font-heading space-y-6">
              <p>
                Yoybuy Spreadsheet — это современная табличная система, которая делает покупки из Китая простыми и безопасными. В отличие от традиционных агентов, вы получаете полный контроль над каждым заказом, прозрачное ценообразование и быструю обработку запросов.
              </p>
              <p>
                Мы объединили лучшие практики Kakobuy Spreadsheet и Superbuy Spreadsheet, добавили собственные уникальные инструменты и создали систему, которая действительно работает для покупателей из Европы.
              </p>
            </div>
          </div>

          <div className="lg:w-7/12">
            <div className="grid grid-cols-2 gap-8 md:gap-12">
              <div>
                <span className="text-5xl md:text-6xl font-heading font-bold text-foreground-950 whitespace-nowrap">10K+</span>
                <p className="mt-2 text-sm text-foreground-500 whitespace-nowrap">Успешных заказов</p>
              </div>
              <div>
                <span className="text-5xl md:text-6xl font-heading font-bold text-foreground-950 whitespace-nowrap">24/7</span>
                <p className="mt-2 text-sm text-foreground-500 whitespace-nowrap">Поддержка клиентов</p>
              </div>
              <div>
                <span className="text-5xl md:text-6xl font-heading font-bold text-primary-500 whitespace-nowrap">100%</span>
                <p className="mt-2 text-sm text-foreground-500 whitespace-nowrap">Защита покупателей</p>
              </div>
              <div>
                <span className="text-5xl md:text-6xl font-heading font-bold text-accent-500 whitespace-nowrap">14</span>
                <p className="mt-2 text-sm text-foreground-500 whitespace-nowrap">Категорий товаров</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}